var FileWrapper = require('filewrapper');
var FileInlineView = require('fileinlineview');

var FileTreeView = Backbone.View.extend({
    initialize: function (options) {
        this.tree = options.fileTree;
        this.session = options.session;
        this.files = [];
        this.fileViews = {};
        this.uploadPromises = {};
        this.uploadProgress = {};

        this.treeRender = this.renderFullTree();
    },
    uploadFiles: function () {
        _.each(this.files, function (file) {
            var uploaded = file.upload();
            this.uploadPromises[file.getUploadId()] = uploaded;
        }, this);
        return this.uploadPromises;
    },
    cancelUpload: function () {
        _.each(this.files, function (file) {
            file.cancelUpload();
        }, this);
    },
    removeFile: function (fileView) {
        var file = fileView.model;
        this.files = _.without(this.files, file);
        delete this.fileViews[file.getUploadId()];
        delete this.uploadPromises[file.getUploadId()];
        delete this.uploadProgress[file.getUploadId()];
        fileView.remove();
    },
    dummyMessage: function (options) {
        options = options || {};
        var dummyMessage = _.map(this.files, function (file) {
            return file.dummyUrl();
        }, this).join(' ');
        if (options.message) {
            dummyMessage = options.message + ' ' + dummyMessage;
        }
        return dummyMessage;
    },
    renderLocalInlinePreview: function (buffer, options) {
        var extraHtml = $('<span>');

        var previewsToLoad = this.files.length;
        var previewsLoaded = new $.Deferred();
        previewsLoaded.progress(function () {
            previewsToLoad--;
            if (!previewsToLoad) {
                previewsLoaded.resolve(extraHtml);
            }
        });
        _.each(this.files, function (file) {
            var inlineView = this.fileViews[file.getUploadId()];
            var promise = this.uploadPromises[file.getUploadId()];
            var progress = inlineView.renderLocalInlineProgress(promise, options);
            var wrap = $('<span class="fileProgress">');
            wrap.append(progress);
            var el = $('<span class="fileWrap">');
            inlineView.setElement(el);
            extraHtml.append(el.append(wrap));
            this.uploadProgress[file.getUploadId()] = progress;

            if (options.filenames) {
                file.desiredFilename = options.filenames['name[' + file.getUploadId() + ']'];
            }

            inlineView.renderLocalInlinePreview().done(function (preview) {
                wrap.append(preview);
                previewsLoaded.notify();
            });
            file.setReqId(buffer, options.reqid);
        }, this);
        return previewsLoaded.promise();
    },
    finaliseFiles: function (options) {
        var filesToProcess = this.files.length;
        var allProcessed = new $.Deferred();
        allProcessed.progress(_.bind(function (file) {
            filesToProcess--;
            if (!filesToProcess) {
                allProcessed.resolve();
            }
        }, this));
        _.each(this.files, function (file) {
            file.triggerBubble('uploadConfirmed');
            var uploaded = this.uploadPromises[file.getUploadId()];
            uploaded.done(function (uploadResponse) {
                file.finalise(options, function (finaliseResponse) {
                    allProcessed.notify(file);
                });
            }).fail(function (errorString, errorResponse) {
                allProcessed.notify(file, errorString, errorResponse);
            });
        }, this);
        return allProcessed.promise();
    },
    processFinalised: function () {
        var finalisedFiles = [];
        _.each(this.files, function (file) {
            if (file.isUploaded()) {
                finalisedFiles.push(file);
            } else {
                var progress = this.uploadProgress[file.getUploadId()];
                if (progress) {
                    progress.removeClass('busy');
                    progress.css('height', 0);
                }
            }
        }, this);
        return finalisedFiles;
    },
    renderFullTree: function () {
        var root = $('<ul class="root">');
        _.each(this.tree, function (node) {
            this.renderTree(node, root);
        }, this);
        root.on('change', 'input[type=checkbox]', _.bind(function (e) {
            this.files = _.map(root.find('input.uploadPreviewName:not([disabled])'), function (input) {
                return $(input).data('file');
            });
        }, this));
        return root;
    },
    renderTree: function (node, list, depth) {
        depth = depth || 0;
        var nodeItem = $('<li class="form">');
        if (node.dir) {
            if (!node.children.length) {
                return false;
            }
            var newList = $('<ul>');
            var children = false;
            _.each(node.children, function (child) {
                if (this.renderTree(child, newList, depth + 1)) { 
                    children = true;
                }
            }, this);
            if (children) {
                var dirIcon = $('<span class="dirIcon">')
                    .append('<span class="dirIconTab">')
                    .append('<span class="dirIconBody">');
                nodeItem.append($('<p class="directory">').text(node.dir).prepend(dirIcon));
                nodeItem.append(newList);
            }
        } else {
            var fw = FileWrapper.fromFile(node, this.session);
            fw.setUploadId();
            var fv = new FileInlineView({
                model: fw
            });
            var previewContainer = $('<span class="treePreview">');
            fv.renderLocalPreview().done(function (preview) {
                previewContainer.append(preview);
                if (fw.isPreviewable()) {
                    var img = preview.find('img');
                    var width = img.width();
                    var height = img.height();
                    img.css({
                        marginTop: -height/2,
                        marginLeft: -width/2
                    }).addClass('rendered');
                }
            });

            var checkbox = $('<input type="checkbox" tabindex="-1">');

            var info = $('<span class="info explanation">');
            var type = fw.getType();
            if (type) {
                type += ' • ';
            }
            info.text(type + fw.getSize());

            var name;
            if (fw.isTooLarge()) {
                nodeItem.addClass('disabled tooLarge');
                checkbox.prop('disabled', true);
                name = $('<span class="name">').text(fw.getName());
            } else {
                var idAttr = 'uploadPreviewName' + fw.getUploadId();
                var nameAttr = 'name[' + fw.getUploadId() + ']';
                name = $('<input class="input uploadPreviewName">').attr({
                    'id': idAttr,
                    name: nameAttr
                }).data('file', fw).css('width', FileTreeView.MAX_INPUT_WIDTH-(FileTreeView.DEPTH_PAD*depth));
                name.val(fw.getName());
                checkbox.prop('checked', true);
                checkbox.on('change', function () {
                    var checked = checkbox.is(':checked');
                    name.prop('disabled', !checked);
                    nodeItem.toggleClass('disabled', !checked);
                });
                previewContainer.on('click', function () {
                    checkbox.prop('checked', !checkbox.is(':checked')).change();
                });
                this.files.push(fw);
                this.fileViews[fw.getUploadId()] = fv;
            }

            nodeItem
                .append(previewContainer)
                .append(checkbox)
                .append(' ')
                .append(name)
                .append(' ')
                .append(info);
        }
        list.append(nodeItem);
        return true;
    }
}, {
    // Sync with css
    MAX_INPUT_WIDTH: 475,
    DEPTH_PAD: 16
});

module.exports = FileTreeView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/filetreeview.js
// module id = 8SYU
// module chunks = 1